<template>
  <!-- 居家感统入门课程 -->
  <div class="jujiagantongrumenkecheng">
    <PublicCert :logo="Logo12" :type="'jy-hsi'" :color="'#3390cf'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo12 from '@/assets/images/logo12.png'

export default {
  name: 'JuJiaGanTong',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo12
    }
  }
}
</script>
